var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NotFound text-center"},[_c('van-icon',{attrs:{"name":"warning-o","color":"#ff976a","size":"2.5rem"}}),_c('div',{staticClass:"padding5"},[_vm._v("您访问的页面不存在或暂时不可用，请检查网址后重试。")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }